import styled from 'styled-components'
import { Box } from 'ui'

export const AcknowledgementCheck = styled(Box).attrs({
  backgroundColor: 'primary',
  color: 'white',
})``
